import { render, staticRenderFns } from "./FormEditMenuPaket.vue?vue&type=template&id=5773ed60"
import script from "./FormEditMenuPaket.vue?vue&type=script&lang=js"
export * from "./FormEditMenuPaket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports